<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'finduser',
})
</script>
<template>
  <a-modal v-model:open="opend" @ok="submit"  @cancel="onCancel">
         <a-input-search
          placeholder="input search text"
          style="width: 200px"
          @search="onSearch"
        />
        <a-divider />
        <a-checkbox-group v-if="mode=='muti'"  v-model:value="selected">
          <a-checkbox :style="{display: 'flex',lineHeight:'30px',
  height: '30px',}" v-for="(item,i) in dataSource" :key="i" :value="item.userid">
              {{ item.username }} <span class="text-gray"> {{ item.tel }}</span>
          </a-checkbox>
        </a-checkbox-group>
        <a-radio-group v-else v-model:value="selected">
            <a-radio :style="{display: 'flex',lineHeight:'30px',
  height: '30px',}" v-for="(item,i) in dataSource" :key="i" :value="item.userid">
              {{ item.username }} <span class="text-gray"> {{ item.tel }}</span>
          </a-radio>
        </a-radio-group>
</a-modal>
</template>
<script setup lang="ts" name="finduser">
import { onMounted, reactive,ref ,watch,defineProps,defineEmits} from 'vue';
import api from '@/utils/http/service'
import {addip} from '@/utils/util'
  const props=defineProps({
    open:{type:Boolean,default:false},
    mode:{type:String,default:'single'} //single,muti
    })
  const emit=defineEmits(['update:open','change'])
  const opend=ref<boolean>(false)
  const selected=ref<String,Array>('')
  let dataSource=ref<Array>([])
  onMounted(()=>{
    if(props.mode==='muti'){
      selected.value=[]
    }
  })
  const onSearch=(value)=>{
    api.user.list({pageFlag:false,keyword:value}).then(res=>{
      if(res.state==1){
        dataSource.value=res.data
      }
    })
  }
  const onCancel=()=>{
    opend.value=false
    emit('update:open',opend.value)
  }
  const submit=():void=>{
    emit('change',selected.value)
    emit('update:open',false)
  }
  watch(()=>props.open,(n)=>{
    opend.value=n
  })
</script>
